export enum Sorts {
    ASC = "asc",
    DESC = "desc",
}